import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { BrowserView, MobileView } from 'components/DeviceDetect'

const CategoryProductGridSkeleton = ({ itemCount = 20 }) => {
  return (
    <>
      {/* Filter and sorting skeleton - Desktop */}
      <BrowserView>
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            <Skeleton
              width={120}
              height={36}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
            <Skeleton
              width={100}
              height={36}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          </div>
          <Skeleton
            width={200}
            height={20}
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>
      </BrowserView>

      {/* Mobile filter buttons */}
      <MobileView>
        <div className="flex gap-3 mb-6">
          <Skeleton
            width={80}
            height={40}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-lg"
          />
          <Skeleton
            width={100}
            height={40}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-lg"
          />
        </div>
      </MobileView>

      {/* Products grid skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-8">
        {Array(itemCount)
          .fill()
          .map((_, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md border-t-2 border-[#f9fafb] mt-10 transition-all duration-300 hover:shadow-lg"
            >
              {/* Product image skeleton */}
              <div className="relative h-[140px] md:h-[180px]">
                <Skeleton
                  height="100%"
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                />
                {/* Stock status skeleton */}
                <div className="absolute top-2 left-2">
                  <Skeleton
                    width={60}
                    height={16}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="!rounded-full"
                  />
                </div>
              </div>

              <div className="p-3 md:p-5">
                {/* Product title skeleton */}
                <div className="mb-1 min-h-[18px]">
                  <Skeleton
                    width={80}
                    height={13}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                </div>

                {/* Product subtitle skeleton */}
                <div className="h-[2.6em] md:h-[2.5em] mb-3">
                  <Skeleton
                    count={2}
                    height={15}
                    baseColor="#f8fafc"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                </div>

                {/* Price skeleton */}
                <div className="flex items-center gap-1.5 md:gap-2 min-h-[34px] min-[1199px]:min-h-[40px] mb-3">
                  <Skeleton
                    width={60}
                    height={19}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                  <Skeleton
                    width={40}
                    height={13}
                    baseColor="#f8fafc"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                </div>

                {/* Buy button skeleton */}
                <div className="flex gap-1 md:gap-2 justify-between items-center">
                  <Skeleton
                    width={28}
                    height={20}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="md:!w-[42px] md:!h-[32px] !rounded-full flex-shrink-0"
                  />
                  <Skeleton
                    width={138}
                    height={20}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="md:!h-[32px] !rounded-full flex-shrink-0"
                  />
                  <Skeleton
                    height={32}
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="flex-1 md:!h-[40px] !rounded-full"
                  />
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Pagination skeleton */}
      <div className="flex justify-center items-center gap-2 mt-8">
        {Array(5)
          .fill()
          .map((_, index) => (
            <Skeleton
              key={index}
              width={40}
              height={40}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          ))}
      </div>
    </>
  )
}

export default CategoryProductGridSkeleton
